import { TriState } from "../../../models";
import { TourismPotential } from "../../../models";
import { DisabledAccessPotential } from "../../../models";
import { ExplorationPotential } from "../../../models";
import { CaveRating } from "../../../models";
import { LocationType } from "../../../models";
import { IFilter } from "../../Filter";
import { Kernel } from "../../Kernel";
import { PlaceTable } from "../../backend/cloud/PlaceTable";
import { FormsT } from "../form/FormTypes";
import { ProtectionLevel } from "../../User";
import { EntryType } from "../../../models";
import { WaterType } from "../../../models";
import { getCountryName } from "../../Format";

export const StandardFields: Array<FormsT> = [
    /*{
        type: "booleanDropdown",
        title: "Show deleted",
        property: "deleted",
    },*/
    {
        type: "select",
        title: "Country",
        property: "country",
        choices: () =>
            Kernel.instance()
                .dataStore.getSource<PlaceTable>("places")
                .countries.map((x) => x.name),
        displayText: (x) => (x === "All" ? x : (getCountryName(x) ?? "Unknown")),
    },
    {
        type: "select",
        title: "State",
        property: "state",
        choices: (filter: IFilter) => {
            const countryName = filter?.country ?? "Unknown";

            const country = Kernel.instance()
                .dataStore.getSource<PlaceTable>("places")
                .countries.filter((x) => x.name === countryName)[0];

            return country ? [...country.states.values()] : [];
        },
    },
    {
        type: "enumMultiSelect",
        title: "Place type",
        property: "type",
        enumType: LocationType,
    },
    {
        type: "enumMultiSelect",
        title: "Entry type",
        property: "entryType",
        enumType: EntryType,
    },
    {
        type: "enumMultiSelect",
        title: "Water type",
        property: "waterType",
        enumType: WaterType,
        visible: "c",
    },
    {
        type: "enumMultiSelect",
        title: "Dive rating",
        property: "caveRating",
        enumType: CaveRating,
    },
    {
        type: "enumMultiSelect",
        title: "Vertical Access",
        property: "verticalAccess",
        enumType: TriState,
        visible: "c",
    },
    {
        type: "enumMultiSelect",
        title: "Goes to water",
        property: "goesToWater",
        enumType: TriState,
        visible: "c",
    },
    {
        type: "enumMultiSelect",
        title: "Exploration",
        property: "exploration",
        enumType: ExplorationPotential,
        visible: "c",
    },
    {
        type: "enumMultiSelect",
        title: "Tourism",
        property: "tourism",
        enumType: TourismPotential,
        visible: "c",
    },
    {
        type: "enumMultiSelect",
        title: "Disabled access",
        property: "disabledAccess",
        enumType: DisabledAccessPotential,
    },
];

export const AdvancedFields: Array<FormsT> = [
    {
        type: "textInput",
        title: "Place name",
        property: "nameQuery",
    },
    {
        type: "textInput",
        title: "Reference",
        property: "referenceQuery",
    },
    {
        type: "enumMultiSelect",
        title: "Protection level",
        property: "protectionLevel",
        enumType: ProtectionLevel,
        filter: (x: ProtectionLevel) => Kernel.instance().user?.inGroup(x) ?? false,
    },
    {
        type: "booleanOrAllDropdown",
        title: "Has description",
        property: "hasDesc",
    },
    {
        type: "booleanOrAllDropdown",
        title: "Has Survey",
        property: "hasSurvey",
    },
    {
        type: "booleanOrAllDropdown",
        title: "Has Reports",
        property: "hasReports",
    },
    {
        type: "booleanOrAllDropdown",
        title: "Location known",
        property: "hasLocation",
    },
    {
        type: "booleanOrAllDropdown",
        title: "Has been checked",
        property: "checked",
    },
    {
        type: "textInput",
        title: "ID",
        property: "idQuery",
    },
    {
        type: "textInput",
        title: "Notes",
        property: "notesQuery",
    },
    {
        type: "textInput",
        title: "Source",
        property: "sourceQuery",
    },
    {
        type: "textInput",
        title: "Labels",
        property: "labelsQuery",
    },
    {
        type: "textInput",
        title: "Checked by",
        property: "checkedByQuery",
    },
    {
        type: "optionalNumber",
        title: "Max distance from water table",
        property: "withinHeightOfWaterTable",
        placeholder: "Distance in meters",
    },
];
